import { CourseTypes } from 'config';
import { CourseTypeNames } from 'types/course';
import { CourseForGroup } from 'types/group';
import { ImageFields, ImagePreset, Images } from 'types/photo';
import { GroupTypes } from 'types/workout';

export interface GroupFormValuesProps {
  name: string;
  type: GroupTypes;
  active: boolean;
  courses: CourseForGroup[];
  used: number[];
}

export const TYPE_COURSE = [
  { label: 'Все', value: 0 },
  { label: 'Курс', value: 1 },
  { label: 'Тренировка', value: 2 },
  { label: 'Комплекс', value: 3 },
];

export enum GROUP_TAB_VALUES {
  INFO = 'info',
  STYLING = 'styling',
  WORKOUTS = 'workouts',
  SORT = 'sort',
}

export const courseTypeOptions: { value: CourseTypes; label: string }[] = [
  { value: CourseTypes.COURSE, label: CourseTypeNames[CourseTypes.COURSE] },
  { value: CourseTypes.MARATHON, label: CourseTypeNames[CourseTypes.MARATHON] },
  { value: CourseTypes.COMPLEX, label: CourseTypeNames[CourseTypes.COMPLEX] },
  { value: CourseTypes.WORKOUT, label: CourseTypeNames[CourseTypes.WORKOUT] },
  { value: CourseTypes.BROADCAST, label: CourseTypeNames[CourseTypes.BROADCAST] },
  { value: CourseTypes.CHALLENGE, label: CourseTypeNames[CourseTypes.CHALLENGE] },
];

export const GROUP_IMAGES_PRESETS: Record<keyof Images, ImagePreset> = {
  [ImageFields.MOBILE]: {
    width: 140,
    height: 140,
    title: 'Мобильная версия',
  },
  [ImageFields.DESKTOP]: {
    width: 140,
    height: 140,
    title: 'ПК версия',
  },
};

export const MUSCLES_GROUP_IMAGES_PRESETS: Record<keyof Images, ImagePreset> = {
  [ImageFields.MOBILE]: {
    width: 290,
    height: 200,
    title: 'Мобильная версия',
  },
  [ImageFields.DESKTOP]: {
    width: 314,
    height: 172,
    title: 'ПК версия',
  },
};
